import { render } from "./ReuseCouponSelector.vue?vue&type=template&id=4724f900"
import script from "./ReuseCouponSelector.vue?vue&type=script&lang=ts"
export * from "./ReuseCouponSelector.vue?vue&type=script&lang=ts"
script.render = render

export default script